'use strict';

function CnMailController($translate) {
  var vm = this;

  vm.$onInit = $onInit;

  vm.onFormChange = onFormChange;
  vm.onFormSubmit = onFormSubmit;
  vm.onFormReset = onFormReset;
  vm._getChanges = _getChanges;

  function $onInit() {
    vm.subject = vm.subject || '';
    vm.message = vm.message || '';
    vm.signature = vm.signature || '';
    vm.modal = vm.modal === true || false;
    vm.onChange = vm.onChange();
    vm.onSubmit = vm.onSubmit();
    vm.onReset = vm.onReset();

    $translate([vm.subject, vm.message, vm.signature], {'first_name': vm.firstName, 'last_name': vm.lastName}).then(function(translated) {
      vm.subject = translated[vm.subject];
      vm.message = translated[vm.message];
      vm.signature = translated[vm.signature];
      vm.onFormChange(vm.form.$valid);
    });
  }

  function _getChanges(valid) {
    return {
      valid: valid,
      subject: vm.subject,
      message: vm.message,
      signature: vm.signature
    };
  }

  function onFormChange(valid) {
    (vm.onChange || function() {})(vm._getChanges(valid));
  }

  function onFormSubmit(valid) {
    vm.active = true;
    (vm.onSubmit || function() {})(vm._getChanges(valid));
  }

  function onFormReset() {
    (vm.onReset || function() {})();
  }
}

module.exports = CnMailController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-mail/cn-mail.controller.js
 ** module id = 67
 ** module chunks = 0
 **/